import React from 'react';
import { Upload } from 'antd';
import { GlobalApi } from '../../../abs/config/api';
import commonUtils from '../../../utils/commonUtils';
import { IABSUploadAvatarProps } from '../interface';
import './index.less';
export default class Avatar extends React.Component<IABSUploadAvatarProps, any> {
  constructor(props: IABSUploadAvatarProps) {
    super(props);
    const { url } = props;
    this.state = {
      imageUrl: commonUtils.getAvatar(url),
      fileCode: ''
    };
  }

  componentWillReceiveProps(nextProps: IABSUploadAvatarProps) {
    if (nextProps.url !== this.props.url) {
      this.setState({
        imageUrl: commonUtils.getAvatar(nextProps.url)
      });
    }
  }

  renderImage() {
    let { imageUrl } = this.state;
    const uploadText = imageUrl !== commonUtils.getAvatar() ? '修改头像' : '上传头像';
    const UploadButton = <div className="ant-upload-text">{uploadText}</div>;
    return (
      <div className="abs-upload-preview">
        <img src={imageUrl} className="abs-upload-preview-image" alt="avatar" />
        {UploadButton}
      </div>
    );
  }

  render() {
    const { size, withCredentials } = this.props;
    const avatarSize = size === 100 ? 'abs-avatar-size100' : '';
    return (
      <div className={`abs-mask ${avatarSize}`}>
        <Upload
          name="avatar"
          className="abs-upload-avatar"
          action={GlobalApi.uploadImgUrl}
          withCredentials={withCredentials}
          listType="picture-card"
          onChange={this.onChange}
          showUploadList={false}
          accept="image/*"
        >
          {this.renderImage()}
        </Upload>
      </div>
    );
  }

  onGetBase64(img: any, callback: (imageUrl: any) => void) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  
  onChange = response => {
    const { file } = response;
    if (file.status === 'done') {
      this.onGetBase64(file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          fileCode: file.response[0].FileCode
        })
      );
      this.onValidator(file.response[0].FileCode);
      const { updateFileCode } = this.props;
      if (updateFileCode) {
        updateFileCode(file.response[0].FileCode);
      }
    }
  };
  
  onValidator = data => {
    const { onValidator } = this.props;
    if (onValidator) {
      onValidator(data);
    }
  };

  getValue = () => {
    const { fileCode } = this.state;
    return fileCode;
  }

  reset = () => {
    const { url } = this.props;
    this.setState({
      imageUrl: commonUtils.getAvatar(url),
      fileCode: ''
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSUpload/Avatar/index.tsx